import { render, staticRenderFns } from "./Facilities.vue?vue&type=template&id=185a1e06&scoped=true"
import script from "./Facilities.vue?vue&type=script&lang=js"
export * from "./Facilities.vue?vue&type=script&lang=js"
import style0 from "./Facilities.vue?vue&type=style&index=0&id=185a1e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185a1e06",
  null
  
)

export default component.exports